
export default {
  props: ["path", "name", "children"],
};
